<div class="container-fluid">

  <header class="row mt-5 ms-3 me-3">
    <div class="col-12 col-md-12 col-lg-4 col-xl-2 col-xxl-1">
      <img src="../../../assets/images/logo-blue@3x.png" style="width: 125px;">
    </div>
    <div class="col-12 col-md-12 col-lg-8 col-xl-10 col-xxl-11 step-container">
      <ul class="step step-md step-inline">
        <li class="step-item active">
          <div class="step-content-wrapper">
            <span class="step-icon step-icon-primary">1</span>
            <div class="step-content">
              <h4 class="step-title">Créez votre compte</h4>
            </div>
          </div>
        </li>
        <li class="step-item">
          <div class="step-content-wrapper">
            <span class="step-icon step-icon-soft-primary">2</span>
            <div class="step-content">
              <h4 class="step-title">Créez votre entreprise</h4>
            </div>
          </div>
        </li>


        <li class="step-item">
          <div class="step-content-wrapper">
            <span class="step-icon step-icon-soft-primary">3</span>
            <div class="step-content">
              <h4 class="step-title">Choisissez votre abonnement</h4>
            </div>
          </div>
        </li>

        <li class="step-item">
          <div class="step-content-wrapper">
            <span class="step-icon step-icon-soft-primary">4</span>
            <div class="step-content">
              <h4 class="step-title">Bienvenue dans Optitax!</h4>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </header>

  <main class="mt-4">
    <div class="row d-flex align-items-center">
      <div class="col-12 col-lg-6 offset-xl-1">
        <div class="form-container">
          <h1 class="display-2 text-center mb-3">Bienvenue dans Optitax!</h1>

          <h3 class="display-4 mt-5"><i class="far fa-hourglass-half"></i> Seulement 3 étapes et vous serez parmi nous.
        </h3>

        <p class="text-secondary" style="font-size: 1.25em; margin-top: 45px; margin-bottom: 45px;">La première étape
          est de vous créer un compte. Vous allez être redirigé vers notre partenaire de connexion pour créer votre
          compte sécurisé. Ne vous inquiétez pas, une fois que vous aurez créer
        votre compte, vous serez redirigé ici!</p>


        <div class="form-check mt-3 mb-3">
          <div class="row">
            <div class="col-12 col-md-10">
              <input [(ngModel)]="termsAndConditions" [defaultChecked]="false"
                class="form-check-input"
                id="terms_and_conditions"
                name="terms_and_conditions"
                type="checkbox">
              <label class="form-check-label"
                for="terms_and_conditions">J'accepte les <a href="https://optitax.ca/conditions-utilisation"
                target="_blank">conditions
              d'utilisation</a></label>

              @if (hasTriedToSubmit && termsAndConditions === false) {
                <div
                  class="invalid-feedback d-block">
                  <p>Vous devez accepter les conditions d'utilisation</p>
                </div>
              }
            </div>
          </div>
        </div>

        <div class="d-grid">
          <button (click)="redirect()" class="btn btn-lg btn-primary">Débuter mon inscription</button>
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-xl-5 col-xxl-4 d-none d-sm-none d-md-none d-lg-block illustration pt-5">
      <img class="img-fluid" src="../../../../assets/images/optitax-app-demo-illustration.svg">
    </div>
  </div>
</main>

</div>